import { FC, PropsWithChildren, useState } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Provider } from 'react-redux'
import { GlobalStyles } from 'globalStyle'
import { SnackbarContainer } from '@mrshmllw/smores-react'

import { OuterError } from './Error/OuterError'
import { Router } from './router/Router'

import { store } from 'app/store'
import { report, Storage as storage, TrackingProvider } from 'utils'

const Wrapper: FC<PropsWithChildren> = ({ children }) => {
  return (
    <TrackingProvider>
      <Provider store={store}>
        <SnackbarContainer>
          {children}
          <GlobalStyles key="globalstyles" />
        </SnackbarContainer>
      </Provider>
    </TrackingProvider>
  )
}

const ErrorFallback: FC = () => {
  return (
    <Wrapper>
      <OuterError />
    </Wrapper>
  )
}

export const App: FC = () => {
  const [existingQuoteId] = useState(() => storage.get('quoteId'))

  return (
    <ErrorBoundary
      // in case something is wrong with the router and we still see an error after pushing to /error,
      // show fallback directly
      fallback={<ErrorFallback />}
      onError={(error, info) => {
        report(error, 'Outer error fallback', { args: { info } })
      }}
    >
      <Wrapper>
        <Router existingQuoteId={existingQuoteId} />
      </Wrapper>
    </ErrorBoundary>
  )
}
